import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Modal, Select } from '../../../../components';
import { SelectOption } from '../../../../components/Select/SelectOption';
import { updateUser } from '../../../../store/users/users.actions';
import { Role, User } from '../../../../types';

import userIcon from './user.svg';

type AssignRoleModalProps = {
  onClose: () => void;
  user: User | null;
  open: boolean;
};

export const AssignRoleModal: React.FC<AssignRoleModalProps> = ({
  onClose,
  user,
  open,
}: AssignRoleModalProps): JSX.Element => {
  const [role, setRole] = useState<Role>(user?.role || 'dealmaker');

  const dispatch = useDispatch();

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setRole(e.target.value as Role);
  };

  const handleSave = () => {
    dispatch(updateUser({ role }, user?.orgId || '', user?.userId || ''));
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose} title="Assign a role">
      <div className="assign-role-modal">
        <div className="assign-role-modal__name">
          <img src={userIcon} alt="User" />
          {user?.name}
        </div>
        <Select onChange={handleChange} value={role}>
          <SelectOption
            disabled={['superAdmin', 'owner'].includes(user?.role || '')}
            value="dealmaker"
          >
            Dealmaker
          </SelectOption>
          <SelectOption
            disabled={['superAdmin', 'owner'].includes(user?.role || '')}
            value="admin"
          >
            Admin
          </SelectOption>
        </Select>
        <div className="assign-role-modal__btns">
          <Button
            onClick={handleSave}
            className="assign-role-modal__btns-btn"
            variant="common"
          >
            Save
          </Button>
          <Button
            onClick={onClose}
            className="assign-role-modal__btns-btn"
            variant="text"
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};
